<app-toasts></app-toasts>

<app-loader></app-loader>

<router-outlet></router-outlet>
